// Mock data for Terapia Psicossomática Direta Landing Page

export const mockData = {
  hero: {
    title: "Terapia Psicossomática Direta®",
    subtitle: "Transforme vidas em tempo recorde. A única formação no Brasil que integra Medicina Germânica, Teoria Polivagal e Hipnose Psicossomática para identificar e tratar a verdadeira raiz emocional e biológica dos sintomas.",
    backgroundImage: "https://customer-assets.emergentagent.com/job_mente-corpo-cura/artifacts/stlxb2dy_Untitled%20design%20%2825%29.png",
    profileImage: "https://customer-assets.emergentagent.com/job_mente-corpo-cura/artifacts/tbgu9l3w_Untitled%20design%20%2834%29.png",
    aempLogo: "https://customer-assets.emergentagent.com/job_mente-corpo-cura/artifacts/kfoohrt9_AEMP%20%283%29.png",
    trustBadges: [
      "Formação Internacional",
      "Método Validado Clínico", 
      "Fundamentação Científica"
    ]
  },
  
  mentor: {
    name: "Flor Dirube",
    title: "Especialista em Medicina Psicobiológica",
    titleImage: "https://customer-assets.emergentagent.com/job_mente-corpo-cura/artifacts/ctdo1omn_Copy%20of%20%40neuro.flor.png",
    bio: "A verdadeira medicina nasce quando a ciência se reconcilia com a consciência. Esta mentoria é um convite para compreender a doença como uma expressão inteligente de nossa biologia, não como um inimigo a ser combatido.",
    quote: "Em poucos meses, você estará guiando alguém em sua transformação... e fará isso com a certeza de ter em suas mãos o conhecimento, a experiência e o método para mudar a vida dessa pessoa para sempre. O momento de dar o passo é agora.",
    image: "https://customer-assets.emergentagent.com/job_mente-corpo-cura/artifacts/tbgu9l3w_Untitled%20design%20%2834%29.png",
    credentialsText: "Flor Dirube é formadora e pesquisadora em abordagens integrativas do desenvolvimento humano. Possui formação acadêmica em Counseling Psychology (EUA), com ênfase em Psicologia Humanista, complementada por prática clínica avançada em Argentina e Espanha. Atua há mais de 10 anos na facilitação de processos de desenvolvimento humano, bem como na formação e supervisão de profissionais da saúde integrativa.\n\nSua trajetória inclui estudos avançados em Psicoterapia Humanista, Teoria Polivagal, Psiconeurobiologia, aplicação das 5 Leis Biológicas da Medicina Germânica e Hipnose Clínica, explorando de forma aprofundada as inter-relações entre mente, corpo e emoção sob uma perspectiva integrativa e baseada em evidências.\n\nÉ membro fundador da Academia Europeia de Medicina Psicobiológica e dedica-se à formação de profissionais que buscam excelência clínica, precisão emocional e transformação efetiva na prática terapêutica.",
    credentials: [
      "Membro Fundador da Academia Europeia de Medicina Psicobiológica",
      "Psicoterapeuta Especialista em Medicina Germânica e Biodescodificação Avançada",
      "Pós-graduada em Neurociências do Comportamento",
      "Certificação em Teoria Polivagal", 
      "Master em Hipnose Clínica Psicossomática"
    ]
  },

  learningPillars: [
    {
      title: "Detectar a Origem",
      description: "Aprenda a identificar a origem biológica e emocional dos sintomas através de protocolos científicos precisos.",
      icon: "search"
    },
    {
      title: "Aplicar Protocolos",
      description: "Domine protocolos terapêuticos específicos para restaurar a função orgânica e resolver sintomas definitivamente.",
      icon: "activity"
    },
    {
      title: "Integrar Ferramentas",
      description: "Integre ferramentas científicas aplicáveis no consultório e na vida real para resultados transformadores.",
      icon: "brain"
    }
  ],

  scientificBases: [
    {
      title: "Medicina Germânica",
      description: "Aprenda a aplicar as 5 Leis Biológicas do Dr. Hamer que revelam a lógica biológica por trás dos sintomas, proporcionando uma compreensão revolucionária do processo saúde-doença.",
      image: "https://customer-assets.emergentagent.com/job_therapia-web/artifacts/0fslwopy_Imagens%20LP%20%284%29.png"
    },
    {
      title: "Teoria Polivagal",
      description: "Compreenda como a ciência do sistema nervoso autônomo explica a regulação emocional, a segurança interna e os mecanismos de cura psicossomática.",
      image: "https://customer-assets.emergentagent.com/job_therapia-web/artifacts/4bygg9ss_Imagens%20LP%20%283%29.png"
    },
    {
      title: "Hipnose Clínica Psicossomática",
      description: "Acesse diretamente o Inconsciente Biológico para transformar crenças limitantes, padrões, dissolver traumas e restaurar a função orgânica natural do corpo.",
      image: "https://customer-assets.emergentagent.com/job_therapia-web/artifacts/39ol2p0o_Imagens%20LP%20%282%29.png"
    }
  ],

  modules: [
    {
      title: "Módulo I: Fundamentos da Medicina Psicobiológica",
      duration: "Aula ao vivo",
      objective: "Oferecer uma nova cosmovisão sobre saúde e doença a partir de uma perspectiva biológica, emocional e evolutiva.",
      content: [
        "Fundamentos da Medicina Germânica (Dr. Ryke Geerd Hamer)",
        "As 5 Leis Biológicas",
        "Conflito biológico e sua tradução somática",
        "Introdução à Biodescodificação e à Terapia do Sentido Biológico",
        "Projeto Sentido, Transgeracional e BioShock",
        "Sistema PsicoNeuroImunoEndócrino e eixo intestino-cérebro",
        "Embriologia como mapa para a compreensão dos sintomas",
        "Casos clínicos ilustrativos"
      ]
    },
    {
      title: "Módulo II: Neurociência do Trauma e Teoria Polivagal",
      duration: "Aula ao vivo",
      objective: "Compreender o sistema nervoso autônomo como eixo da regulação emocional, do trauma e da saúde psicossomática.",
      content: [
        "Sistema nervoso autônomo: simpático, parassimpático, ventral/dorsal",
        "Teoria Polivagal (Dr. Stephen Porges)",
        "Neurocepção, hierarquia de estados e vagotonia",
        "Via dorsal: colapso, dissociação e doença crônica",
        "Via ventral: segurança, conexão e reparação",
        "Trauma como congelamento biológico",
        "Ponte entre trauma, sintomas físicos e estados vagais",
        "Exercícios de regulação vagal"
      ]
    },
    {
      title: "Módulo III: O Corpo como Via de Diagnóstico e Cura",
      duration: "Aula ao vivo",
      objective: "Ensinar a leitura do corpo como espelho do inconsciente biológico.",
      content: [
        "Diagnóstico psicobiológico: órgãos e conflitos associados",
        "Fase ativa e fase de reparação",
        "Ciclos de estresse não resolvidos e doenças recorrentes",
        "Impacto da percepção na fisiologia",
        "Casos e práticas clínicas",
        "Trabalho com crenças, fidelidades inconscientes e conflitos transgeracionais"
      ]
    },
    {
      title: "Módulo IV: O Inconsciente Biológico e a Reprogramação",
      duration: "Aula ao vivo",
      objective: "Aplicar ferramentas para liberar a carga traumática e reprogramar a percepção interna.",
      content: [
        "Neurobiologia da crença (Bruce Lipton, Joe Dispenza, David Eagleman)",
        "Ferramentas de intervenção:",
        "• Hipnose terapêutica",
        "• Técnicas somáticas (exercícios vagais, TRT, grounding etc.)"
      ]
    },
    {
      title: "Módulo V: Aplicação Profissional e Integração",
      duration: "Aula ao vivo",
      objective: "Integrar os aprendizados e formar uma práxis ética, profunda e transformadora.",
      content: [
        "Os 4 passos da TPD®",
        "Desenho de sessões terapêuticas",
        "Casos reais supervisionados"
      ]
    },
    {
      title: "+ 12 Encontros de Aprofundamento e Supervisão",
      duration: "Encontros mensais",
      objective: "",
      content: [
        "Encontros mensais de integração, estudo de casos e aprofundamento terapêutico para sustentar a evolução clínica e pessoal do terapeuta."
      ]
    }
  ],

  testimonials: [
    {
      name: "Dr. Alexandre Martin",
      profession: "Médico Acupunturista - CRM-SP 100432, RQE 21213",
      image: "https://customer-assets.emergentagent.com/job_mente-corpo-cura/artifacts/tz8wbd6j_Untitled%20design%20%2848%29.png",
      testimonial: "Na minha opinião, o futuro da medicina e de todas as modalidades terapêuticas que objetivam o bem estar integral do indivíduo repousa no caminho da medicina psicossomática. Todo médico, independente da sua especialidade ou área de atuação, se beneficia com o seu estudo. Florência Dirube se mostra uma profissional impecável, da maior competência e habilidade para capacitar, em tão pouco tempo, os profissionais da saúde para terem resultados expressivos e efetivos com todos os seus pacientes. Considero a capacitação mandatória e fundamental! Tive enorme crescimento pessoal e profissional. Extremamente grato por fazer parte!",
      type: "student"
    },
    {
      name: "Jaqueline Scarelli Martin",
      profession: "Osteopata",
      image: "https://customer-assets.emergentagent.com/job_mente-corpo-cura/artifacts/jmcyxrf8_Untitled%20design%20%2849%29.png",
      testimonial: "A formação em Terapia Psicossomática me trouxe grande revelação a respeito dos meus comportamentos, bloqueios e sintomas, nos convida a enxergar o que está por trás disso, decodificar, entender e ressignificar. Como profissional da saúde recomendo muito, irá iluminar o caminho de muitos. A Flor nos conduz de uma maneira muito competente, gentil e amorosa.",
      type: "student"
    }
  ],

  clinicalCases: [
    {
      title: "Obesidade resolvida em 10 sessões",
      subtitle: "Perda de 10kg através da TPD®",
      description: "Caso clínico documentado de tratamento de obesidade com a Terapia Psicossomática Direta, demonstrando resultados expressivos em tempo recorde através da identificação e tratamento da raiz emocional.",
      image: "https://customer-assets.emergentagent.com/job_therapia-web/artifacts/phx36htf_Antes%20%282%29.png",
      type: "clinical"
    }
  ],

  clinicalCase: {
    title: "Caso Clínico Documentado",
    description: "Tumor na Órbita Ocular em Remissão após 5 Sessões",
    image: "https://customer-assets.emergentagent.com/job_mente-corpo-cura/artifacts/83jvryj5_TUMOR%20NA%20%C3%93RBITA%20OCULAR%20EM%20REMISS%C3%83O%20%282%29.png",
    subtitle: "Resultado extraordinário obtido através da aplicação da Terapia Psicossomática Direta®"
  },

  targetAudience: [
    "Profissionais da saúde",
    "Psicólogos e psicoterapeutas",
    "Terapeutas holísticos",
    "Coaches especializados em saúde",
    "Profissionais com formação em terapias complementares"
  ],

  investment: {
    price: "R$ 3.500",
    originalPrice: "R$ 5.500",
    installments: "ou até 12x de R$ 291,67",
    highlight: "Última turma com valor promocional"
  },

  contact: {
    whatsapp: "+34603456844",
    email: "info@psicobiologica.com",
    instagram: "@neuro.flor"
  },

  scientificImages: {
    neuralNetwork: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
    molecules: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
    dna: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
    brain: "https://images.unsplash.com/photo-1606672897701-8858c6ee9b8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
  },

  video: {
    youtubeId: "vLjaxJhD27s",
    title: "A nova era da terapia clínica começou.",  
    description: "Acesse o núcleo real da doença tratando a raiz, e não o sintoma."
  },

  benefits: [
    {
      title: "100% Preparação real para a prática",
      description: "Chega de cursos teóricos sem aplicação. Desde o primeiro módulo, você vai trabalhar com casos reais e práticas supervisionadas."
    },
    {
      title: "Formação online de máxima qualidade",
      description: "Aulas ao vivo, materiais exclusivos, aprendizagem flexível, para que você possa se formar de qualquer lugar do mundo."
    },
    {
      title: "Últimas inovações em terapia breve",
      description: "Você não aprenderá apenas técnicas tradicionais, mas integrará os avanços mais modernos em Biodescodificação, Hipnose Clínica e Psicossomática."
    },
    {
      title: "Acesso a uma comunidade de especialistas",
      description: "Faça parte de um grupo de terapeutas de alto nível, com mentorias ao vivo, networking profissional e supervisão contínua."
    },
    {
      title: "Material exclusivo e ferramentas avançadas",
      description: "Recursos práticos, scripts de hipnose, protocolos terapêuticos e técnicas estruturadas para que você saiba sempre o que fazer em cada sessão."
    },
    {
      title: "Acompanhamento especializado e personalizado",
      description: "Você não estará sozinho(a). Terá acesso direto a docentes e mentores que vão responder às suas dúvidas e acompanhar sua evolução."
    },
    {
      title: "Certificação Internacional AEMP",
      description: "Selo de prestígio da Academia Europeia de Medicina Psicobiológica que te permitirá atuar com total segurança e reconhecimento internacional."
    }
  ],

  skills: [
    "Aprenderá a identificar a origem emocional do sintoma/doença em minutos",
    "Dominará o mapa claro e infalível da TPD® que correlaciona: Órgão - Região Cerebral - Conflito Emocional - Resposta do Sistema Nervoso",
    "Reprogramará crenças e comportamentos no nível subconsciente de forma fácil e direta",
    "Dominará técnicas avançadas de regulação vagal (Sistema Nervoso Autônomo)",
    "Aprenderá a desenvolver uma escuta corporal apurada, capaz de captar o que está além das palavras do paciente",
    "Integrará raciocínio clínico e sensibilidade emocional, tornando-se um profissional com leitura humana de alta precisão",
    "Aprenderá a reconhecer o código emocional de cada órgão, compreendendo a lógica precisa por trás de cada sintoma",
    "Sentir a segurança de saber exatamente o que fazer em cada sessão"
  ],

  didacticMaterials: [
    {
      moduleTitle: "Módulo I - O Corpo",
      pages: "200+ páginas",
      topics: [
        "Por que somatizamos em doenças?",
        "Pensamento biológico",
        "Evolução humana",
        "A Origem Evolutiva do Comportamento Humano",
        "O sentido básico da biologia é sobreviver",
        "O Sentido Biológico da Evolução",
        "Endoderma, Mesoderma Antigo, Mesoderma Novo, Ectoderma",
        "Como o Terapeuta pode utilizar o sentido biológico dos sintomas",
        "Memória Celular",
        "Processos para a Cura",
        "Resumo de Conceitos Básicos da TPD®",
        "Presuposições para trabalhar a TPD® baseadas na Nova Medicina Germânica"
      ]
    },
    {
      moduleTitle: "Módulo II - Psicossomática Aplicada",
      pages: "180+ páginas", 
      topics: [
        "Inconsciente Coletivo",
        "Inconsciente Individual",
        "A Teoria Psicossomática",
        "Inconsciente Familiar",
        "Psicogenealogia",
        "O Projeto Sentido Gestacional",
        "Os Ciclos Celulares Biológicos Memorizados",
        "Inconsciente Biológico",
        "Psicossomática Clínica e Humanista",
        "As 14 Leis da Psicossomática",
        "Medicina Tradicional Chinesa: Uma visão geral"
      ]
    },
    {
      moduleTitle: "Módulo III - A Mente",
      pages: "220+ páginas",
      topics: [
        "Mente Consciente e Mente Inconsciente",
        "Características do Inconsciente",
        "O que é uma Crença?",
        "As Crenças Inconscientes",
        "Expectativas e Interpretações",
        "A Crença como Programa",
        "Crenças, Emoções e Comportamentos",
        "Mudança de Crenças",
        "Protocolos Básicos de PNL",
        "Ancoragem",
        "Ancoragens Positivas e Negativas"
      ]
    },
    {
      moduleTitle: "Módulo IV - O Poder da Linguagem",
      pages: "150+ páginas",
      topics: [
        "A linguagem como interação humana",
        "O mundo linguístico",
        "Os atos linguísticos",
        "Afirmações e declarações",
        "Os julgamentos",
        "Metamodelo",
        "Procedimentos de associação e dissociação",
        "Estruturas e estratégias submodais",
        "Premissas que o Terapeuta deve considerar"
      ]
    },
    {
      moduleTitle: "Módulo V - As Emoções (Vista pela Biologia)",
      pages: "300+ páginas",
      topics: [
        "As Emoções – Generalidades",
        "Conhecendo as Emoções",
        "Os Sentimentos",
        "Critérios do Impacto Emocional (DHS)",
        "O Ciclo das Emoções",
        "A Sensação Física como Recurso",
        "Cura Emocional, Liberar o Passado",
        "As Emoções e a Biologia",
        "O que é a Hipnose?",
        "Hipnose Ericksoniana",
        "Os Quatro Estados ou Níveis da Mente",
        "Estados do Ego",
        "Scripts de Induções",
        "Metáforas"
      ]
    },
    {
      moduleTitle: "Módulo VI - As Emoções (Vista pela Linguagem)",
      pages: "160+ páginas",
      topics: [
        "Emoções e Estados de Ânimo",
        "Distinção entre estados de ânimo e emoções",
        "Inteligência Emocional",
        "Vocabulário emocional básico",
        "Alegria, Tristeza, Entusiasmo, Medo, Gratidão, Raiva",
        "Orgulho, Culpa, Vergonha",
        "Reconhecimento da Emoção do Outro",
        "Autoaceitação",
        "Autorregulação"
      ]
    },
    {
      moduleTitle: "Módulo VII - Transcendendo os Níveis de Consciência",
      pages: "140+ páginas",
      topics: [
        "O Mecanismo do Deixar Ir",
        "Transcendendo o Sofrimento",
        "A Transição da Mente Inferior para a Superior",
        "Coragem (Valentia)",
        "Neutralidade (Confiança)",
        "Transcender as Limitações do Intelecto",
        "O Amor",
        "O amor incondicional, Alegria, e o êxtase",
        "A Relação da Consciência com o estresse e a doença",
        "O Problema do Paradigma"
      ]
    },
    {
      moduleTitle: "Módulo VIII - Os Arquétipos e a TPD®",
      pages: "180+ páginas",
      topics: [
        "Como se originou a ideia dos arquétipos?",
        "Os arquétipos e o inconsciente coletivo",
        "Como se expressam os arquétipos?",
        "Os 12 arquétipos Universais de Jung",
        "O Inocente, O Amigo, O Explorador, O Sábio",
        "O Herói, O Rebelde, O Mago, O Amante",
        "O Bufão, O Cuidador, O Criador, O Governante",
        "O ego e os arquétipos",
        "Os 52 Arquétipos de Sobrevivência"
      ]
    },
    {
      moduleTitle: "Módulo IX - TPD® e as Neurociências",
      pages: "200+ páginas",
      topics: [
        "Integração dos módulos",
        "TPD® e física quântica",
        "Padrões de onda: o que enviamos ao campo quântico",
        "Ciclo de Memorização das Emoções",
        "O Lóbulo Frontal e o Estado Criativo",
        "Passar de Pensar para Ser através da Meditação",
        "Introdução à Meditação",
        "Passos para a Meditação Guiada",
        "Revisão da Conexão com o Corpo"
      ]
    },
    {
      moduleTitle: "Módulo X - A Arte do Acompanhamento na TPD®",
      pages: "120+ páginas",
      topics: [
        "Emoções, sentimentos e necessidades",
        "Sensações",
        "Emoções biológicas",
        "Estados de ânimo ou sentimento de fundo",
        "Objetivos das emoções e sentimentos",
        "Acompanhamento da TPD®",
        "Necessidades fundamentais",
        "As 4 Ferramentas da TPD® para um acompanhamento de sucesso",
        "Perguntas abertas, de vínculo, de extensão, de esclarecimento, hipotéticas"
      ]
    }
  ],

  exclusiveMaterials: {
    title: "Material Didático e Bibliografia Exclusiva",
    mainTitle: "Um acervo científico que transforma a prática clínica",
    subtitle: "Esta formação entrega um corpo de conhecimento técnico e clínico construído ao longo de décadas de pesquisa interdisciplinar entre neurociência, psicossomática e medicina germânica.",
    materials: [
      {
        iconImage: "https://customer-assets.emergentagent.com/job_therapia-web/artifacts/zjs4sg8x_Copy%20of%20flor%20dirube%20%283%29.png",
        title: "Manual de Protocolos Psicobiológicos",
        pages: "300 pág.",
        description: "Um guia clínico para compreender e conduzir o corpo em seu próprio idioma biológico. Aplicações práticas e protocolos que unem ciência e consciência."
      },
      {
        iconImage: "https://customer-assets.emergentagent.com/job_therapia-web/artifacts/8ch0da14_Copy%20of%20flor%20dirube.png",
        title: "Dicionário de Decodificação Biológica das Doenças e Patologias",
        pages: "795 pág.",
        description: "Uma obra monumental para compreender o significado emocional por trás de cada sintoma que reúne três décadas de experiência clínica documentada."
      },
      {
        iconImage: "https://customer-assets.emergentagent.com/job_therapia-web/artifacts/dgnykpbt_Copy%20of%20flor%20dirube%20%282%29.png",
        title: "Manual Avançado de Hipnoterapia Psicossomática",
        pages: "250 pág.",
        description: "Integra hipnose clínica, neurofisiologia e biologia do trauma para acessar o corpo como um mapa vivo de experiências."
      },
      {
        iconImage: "https://customer-assets.emergentagent.com/job_therapia-web/artifacts/ox23zz9h_Copy%20of%20flor%20dirube%20%285%29.png",
        title: "Manual de Interpretação Psicoemocional",
        pages: "180 pág.",
        description: "Ferramenta essencial para traduzir padrões emocionais em respostas corporais observáveis, fortalecendo o olhar clínico."
      },
      {
        iconImage: "https://customer-assets.emergentagent.com/job_therapia-web/artifacts/dq7lzdy5_Copy%20of%20flor%20dirube%20%284%29.png",
        title: "Manual de 200 Perguntas da Biodescodificação Infalível",
        pages: "20 pág.",
        description: "Um repertório de perguntas-chave para acessar com precisão o conflito biológico por trás de cada sintoma."
      },
      {
        iconImage: "https://customer-assets.emergentagent.com/job_therapia-web/artifacts/4sodex7k_Copy%20of%20flor%20dirube%20%281%29.png",
        title: "Manual de Terapia Psicossomática (10 Módulos)",
        pages: "700 pág.",
        description: "A síntese de toda a formação. Um percurso completo de integração entre corpo, mente e alma."
      }
    ]
  },

  interventionTools: [
    {
      title: "Manual de Protocolos Psicobiológicos",
      pages: "200 páginas",
      description: "Protocolos estruturados para intervenção terapêutica"
    },
    {
      title: "Manual 200 Perguntas do Terapeuta de Sucesso",
      pages: "150 páginas",
      description: "Guia completo de perguntas estratégicas para sessões"
    },
    {
      title: "Biodicionário de Decodificação das Doenças e Patologias",
      pages: "795 páginas",
      description: "Dicionário completo de sintomas e seus significados psicobiológicos"
    },
    {
      title: "Manual de Interpretação Psicoemocional",
      pages: "180 páginas",
      description: "Guia para interpretação de estados emocionais e sua conexão com sintomas físicos"
    }
  ],

  faq: [
    {
      question: "Não posso assistir no dia do módulo. Vou perder o conteúdo?",
      answer: "De forma alguma. Todas as aulas ao vivo serão gravadas e disponibilizadas na plataforma para você rever quando quiser."
    },
    {
      question: "Por quanto tempo terei acesso às gravações e ao material didático?",
      answer: "Você terá acesso por 12 meses após o início da formação, podendo revisar o conteúdo quantas vezes desejar."
    },
    {
      question: "A mentoria é adequada para iniciantes ou preciso ter formação prévia?",
      answer: "A formação foi construída para profissionais e estudantes da área da saúde, terapias integrativas e desenvolvimento humano, mas também pode ser acompanhada por iniciantes comprometidos. Todo o conteúdo é apresentado de forma acessível, profunda e progressiva."
    },
    {
      question: "Terei certificado ao final?",
      answer: "Sim. Após completar todos os módulos e exercícios indicados, você receberá um Certificado de Formação em Psiconeurobiologia Aplicada, reconhecido pela Academia Europeia de Medicina Psicobiológica."
    },
    {
      question: "Como funcionam os 12 encontros mensais de mentoria?",
      answer: "São encontros mais curtos, focados em tirar dúvidas, revisar casos clínicos e aprofundar pontos específicos. Servem para consolidar os conceitos e manter o suporte contínuo durante a formação."
    },
    {
      question: "A mentoria ajuda com casos reais dos meus clientes/pacientes?",
      answer: "Sim. Os encontros mensais e o grupo de suporte são espaços para discutir casos (de forma ética e anônima) e orientar o uso clínico da teoria."
    },
    {
      question: "O que diferencia esta formação de outros cursos de Medicina Germânica, Biodescodificação ou Polivagal?",
      answer: "Aqui você aprende uma abordagem integrada, científica e clínica, que une Teoria Polivagal, Psiconeurobiologia, Medicina Psicobiológica e leitura simbólica da doença — com foco em prática terapêutica real e em transformação intrapsíquica, não apenas teoria."
    },
    {
      question: "O curso oferece suporte individual?",
      answer: "O suporte principal é via grupo, mas haverá oportunidades de tirar dúvidas durante os encontros e nos espaços de discussão. Acompanhamento individual não está incluído, mas pode ser contratado separadamente."
    },
    {
      question: "Quais são os materiais incluídos na formação?",
      answer: "Você recebe mais de 2.000 páginas de material didático, incluindo: manual de protocolos, dicionário de decodificação, guia avançado de hipnoterapia psicossomática, manual de interpretação psicoemocional e mais."
    },
    {
      question: "A mentoria ensina protocolos práticos para aplicar imediatamente na clínica?",
      answer: "Sim. Cada módulo inclui ferramentas aplicáveis, exercícios de regulação, métodos de investigação psicobiológica, leitura simbólica dos sintomas e protocolos guiados para atendimento."
    }
  ]
};